import { QuoteSheetLineItemDTO } from '@/api/procurement/quote-sheets-types';
import { useUpdateQuoteSheetLineItems } from '@/api/procurement/useUpdateQuoteSheetLineItem';
import { Input } from '@/components/ui/input';
import { useEagerAndDebouncedState } from '@/hooks/useEagerDebouncedState';

export function QuoteSheetUnitPrice({
  lineItem,
}: {
  lineItem: QuoteSheetLineItemDTO;
}) {
  const {
    eagerValue: price,
    // NOTE: currently unused (kept via '_' prefix) — revisit and delete if not needed
    debouncedValue: _debouncedPrice,
    setValue: setPrice,
  } = useEagerAndDebouncedState(
    lineItem.unitPrice != null ? String(lineItem.unitPrice) : '',
    500,
  );

  const { mutate: updateLineItems } = useUpdateQuoteSheetLineItems({
    quoteSheetId: lineItem.quoteSheetId,
  });

  return (
    <Input
      type="number"
      step="0.01"
      value={price}
      onChange={(e) => {
        const inputValue = e.target.value;
        setPrice(inputValue);
      }}
      onBlur={(e) => {
        // Format to 2 decimal places and update the API
        const numValue = Number.parseFloat(e.target.value);
        updateLineItems({
          lineItems: [
            {
              ...lineItem,
              unitPrice: numValue,
            },
          ],
        });
      }}
    />
  );
}
